import { Flow_0_0_2 } from '@flexus/core';

export const BET_86: Flow_0_0_2 = {
	id: '86',
	name: 'quote_approved_sp',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to set new appointment'
		}
	},
	startNode: '',
	nodes: {}
};
